import React from 'react';
import PropTypes from 'prop-types';
import {Field, getIn} from 'formik';
/* Components */
import FormErrorMessage from './form-error-message';

const ErrorMessageFieldArray = ({name}) => (
  <Field name={name}>
    {({form}) => {
      const error = getIn(form.errors, name);
      const touch = getIn(form.touched, name);
      return touch && error ? <FormErrorMessage>{error}</FormErrorMessage> : null;
    }}
  </Field>
);

ErrorMessageFieldArray.propTypes = {
  name: PropTypes.string.isRequired,
};

export default ErrorMessageFieldArray;
